export default {
    nombreCliente: "Clínica",
    tituloPagina: "Solicitud de citas",
    annioCopyright: "2024",
    urlPaginaWeb: "#",	
	mostrarInfoDebug: false,
	urlBaseApis: "http://localhost:80/",
	urlPaginaWeb: "http://localhost:80/"
}